import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-img-envio',
  templateUrl: './img-envio.component.html',
  styleUrls: ['./img-envio.component.css']
})
export class ImgEnvioComponent implements OnInit {
  imagen: boolean = false;

  @Input() public color ;
  constructor() { }

  ngOnInit() {
  }

}
